import CaptainInsightsAPI from 'dashboard/api/captain/insights';
import { createStore, generateMutationTypes } from '../storeFactory';

const mutationTypes = generateMutationTypes('CaptainInsight');

export default createStore({
  name: 'CaptainInsight',
  API: CaptainInsightsAPI,
  getters: {
    getUnreadCount: state =>
      (state.records || []).filter(
        r => r.status === 'unread' && r.insight_type !== 'conversation_summary'
      ).length,
  },
  actions: mutTypes => ({
    // Override default get to support "load more" pagination
    async get({ commit, state }, params = {}) {
      commit(mutTypes.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await CaptainInsightsAPI.get(params);
        const { payload, meta } = response.data;
        if (params.page && params.page > 1) {
          // Append new records, deduplicating by id
          const existingIds = new Set(state.records.map(r => r.id));
          const newRecords = payload.filter(r => !existingIds.has(r.id));
          commit(mutTypes.SET, [...state.records, ...newRecords]);
        } else {
          commit(mutTypes.SET, payload);
        }
        commit(mutTypes.SET_META, meta);
        return payload;
      } catch (error) {
        // Silently handle — sidebar dispatch is fire-and-forget
      } finally {
        commit(mutTypes.SET_UI_FLAG, { fetchingList: false });
      }
    },
    async markRead({ commit, state }, id) {
      await CaptainInsightsAPI.markRead(id);
      const record = state.records.find(r => r.id === id);
      if (record) {
        commit(mutTypes.EDIT, { ...record, status: 'read' });
      }
    },
    async dismiss({ commit, state }, id) {
      await CaptainInsightsAPI.dismiss(id);
      const record = state.records.find(r => r.id === id);
      if (record) {
        commit(mutTypes.EDIT, { ...record, status: 'dismissed' });
      }
    },
    async generateConversationInsight({ commit }, { conversationId, outputs }) {
      const response = await CaptainInsightsAPI.generate(
        conversationId,
        outputs
      );
      const insight = response.data.insight;
      if (insight) {
        commit(mutTypes.ADD, insight);
      }
      return insight;
    },
  }),
});
